export default __webpack_public_path__ + "static/14-38f82f07ab6d248da7d385d7c49c5e40.webp";